/*
import React from "react";

const School = ({ id_school }) => {
  return (
    <div className="training-school-page">
      <h1>School</h1>
      <p>
        Stai visualizzando la pagina per: <strong>{id_school}</strong>
      </p>
      <p>
        Stai visualizzando la pagina per: <strong>{id_school.split("/")[0]}</strong>
      </p>
      <p>
        Stai visualizzando la pagina per: <strong>{id_school.split("/")[1]}</strong>
      </p>
    </div>
  );
};

export default School;
*/

import React, { useEffect, useState } from "react";
import axios from "axios";
//import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import serverConfig from "../config";
import "./Home.css";
//import SidebarLeft from "../SidebarLeft";
//import SidebarRight from "../SidebarRight";

//import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import { momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
//import moment from "moment";
import { useNavigate } from "react-router-dom";

import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import UpdatePaths from "../utils/UpdatePaths";
import toast, { Toaster } from "react-hot-toast";
import SchoolRegistration from "./SchoolRegistration";

//moment.locale("it"); // Imposta la localizzazione su italiano
//const localizer = momentLocalizer(moment);

const School = ({ id_school }) => {
  //const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);
  //const { year_school, name_school } = useParams();

  const [year_school, setYearSchool] = useState(null);
  const [name_school, setNameSchool] = useState(null);
  const [dateRegistration, setDateRegistration] = useState(null);
  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];

  const navigate = useNavigate();

  useEffect(() => {
    //const parts = id_school.split("/")
    const parts = id_school.split("-");
    const year = parts[0];
    const name = parts[1];

    if (!name | !year) {
      navigate("/schools_and_courses"); // Reindirizza se i valori non esistono
    } else {
      setYearSchool(year);
      setNameSchool(name);
    }
  }, [id_school]);

  //const [contentSchool, setContentSchool] = useState(null);
  const [contentSchoolHome, setContentSchoolHome] = useState(null);
  const [contentSchoolIntroduction, setContentSchoolIntroduction] =
    useState(null);
  const [contentSchoolInformation, setContentSchoolInformation] = useState([]);
  const [contentSchoolParticipation, setContentSchoolParticipation] = useState(
    []
  );
  const [contentSchoolProfessorsTxt, setContentSchoolProfessorsTxt] =
    useState(null);
  const [contentSchoolProfessors, setContentSchoolProfessors] = useState(null);
  const [contentSchoolProgramTxt, setContentSchoolProgramTxt] = useState(null);
  const [contentSchoolProgram, setContentSchoolProgram] = useState(null);
  /*
  const [contentSchoolIntroduction, setContentSchoolIntroduction] =
    useState(null);
  const [contentSchoolInformation, setContentSchoolInformation] = useState([]);
  const [contentSchoolParticipation, setContentSchoolParticipation] = useState(
    []
  );
  const [contentSchoolProfessorsTxt, setContentSchoolProfessorsTxt] = useState(
    []
  );
  const [contentSchoolProgramTxt, setContentSchoolProgramTxt] = useState([]);
  */

  useEffect(() => {
    if (year_school && name_school) {
      axios
        .post(`${serverConfig.serverUrl}/get_school`, {
          name_school: name_school,
          year_school: year_school,
        })
        .then((response) => {
          //const data = response.data;

          const data = response.data["data_school"];
          const exist = response.data["exist"];
          if (exist) {
            const updatedContent = {
              home: UpdatePaths(
                data.home,
                //`img/school/${year_school}/${name_school}/IMG/`,
                `img/school/${year_school}/${name_school}/IMG/`,
                `file/school/${year_school}/${name_school}/FILE/`
              ),
              introduction: UpdatePaths(
                data.introduction,
                `img/school/${year_school}/${name_school}/IMG/`,
                `file/school/${year_school}/${name_school}/FILE/`
              ),
              information: UpdatePaths(
                data.information,
                `img/school/${year_school}/${name_school}/IMG/`,
                `file/school/${year_school}/${name_school}/FILE/`
              ),
              participation: UpdatePaths(
                data.participation,
                `img/school/${year_school}/${name_school}/IMG/`,
                `file/school/${year_school}/${name_school}/FILE/`
              ),
              professorsTxt: UpdatePaths(
                data.professorsTxt,
                `img/school/${year_school}/${name_school}/IMG/`,
                `file/school/${year_school}/${name_school}/FILE/`
              ),
              programTxt: UpdatePaths(
                data.programTxt,
                `img/school/${year_school}/${name_school}/IMG/`,
                `file/school/${year_school}/${name_school}/FILE/`
              ),
            };
            setContentSchoolHome(updatedContent["home"]);

            setContentSchoolIntroduction(updatedContent["introduction"]);
            setContentSchoolInformation(updatedContent["information"]);
            setContentSchoolParticipation(updatedContent["participation"]);
            setContentSchoolProfessorsTxt(updatedContent["professorsTxt"]);
            setDateRegistration(data["dateRegistration"]);
            if (Object.keys(data.professors).length > 0) {
              setContentSchoolProfessors(data.professors);
            }

            setContentSchoolProgramTxt(updatedContent["programTxt"]);
            if (Object.keys(data.program).length > 0) {
              setContentSchoolProgram(data.program);
            }
          } else {
            toast.error("Non esiste la scuola indicata");
            navigate("/schools_and_courses");
          }

          //setContentSchool(data);

          /*
        '': 'Participation.txt',
        '': 'Professors.txt',
        '': 'Program.txt',
        'professors': 'Professors.csv',
        'program': 'Program.csv',

        
        const updatedContent = {
          header: UpdatePaths(
            data.header,
            `img/conference/${year_school}/${name_school}/IMG/HOME/`,
            `file/conference/${year_school}/${name_school}/FILE/HOME/`
          ),
          info: UpdatePaths(
            data.info,
            `img/conference/${year_school}/${name_school}/IMG/HOME/`,
            `file/conference/${year_school}/${name_school}/FILE/HOME/`
          ),
          programTxt: UpdatePaths(
            data.programEventTxt,
            `img/conference/${year_school}/${name_school}/IMG/PROGRAM/`,
            `file/conference/${year_school}/${name_school}/FILE/PROGRAM/`
          ),
          sponsorTxt: UpdatePaths(
            data.sponsorTxt,
            `img/conference/${year_school}/${name_school}/IMG/SPONSOR/`,
            `file/conference/${year_school}/${name_school}/FILE/SPONSOR/`
          ),
          submitAbstr: UpdatePaths(
            data.submit_abstr,
            `img/conference/${year_school}/${name_school}/IMG/SUBMISSIONABS/`,
            `file/conference/${year_school}/${name_school}/FILE/SUBMISSIONABS/`
          ),
          infoRegistration: UpdatePaths(
            data.info_registration,
            `img/conference/${year_school}/${name_school}/IMG/INFO/`,
            `file/conference/${year_school}/${name_school}/FILE/INFO/`
          ),
        };
        setContentConferenceHeader(updatedContent["header"]);
        //setContentConferenceInfo(data.info);
        setContentConferenceInfo(updatedContent["info"]);
        setContentConferenceProgramTxt(updatedContent["programTxt"]);
        setContentConferenceSubmitAbstr(updatedContent["submitAbstr"]);
        setContentConferenceInfoRegistration(
          updatedContent["infoRegistration"]
        );

        setContentConferenceSponsor(data.sponsor);
        setContentConferenceProgram(data.programEvent);

        const possibleKeys = ["SPONSORED BY", "SPONSOR", "SPONSORS"];
        let sponsoredBy = possibleKeys.find((key) => data.sponsor[key]);
        sponsoredBy = sponsoredBy ? data.sponsor[sponsoredBy] : [];
        const supportingInstitutions = data.sponsor["SUPPORTING INSTITUTIONS"];
        setContentConferenceSponsoredBy(sponsoredBy);
        setContentConferenceSupportingInstitutions(supportingInstitutions);
        setContentConferenceCommitteess(data.committeeMembers);
        */
        })
        .catch((error) => {
          toast.error("La risorsa non è al momento disponibile");
          // handleError(error);
          //alert("ERRORE | get_school");
          //console.log("CONFERENCE | get_school | error", error);
        });

      localStorage.removeItem("year_school");
      localStorage.removeItem("name_school");
    }
  }, [name_school, year_school]);

  const [activeTab, setActiveTab] = useState("home");
  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const navContents = (
    <>
      <Nav>
        <NavItem>
          <NavLink
            style={
              activeTab === "home"
                ? {
                    color: "#F5F7FA",
                    backgroundColor: "#003366",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "15px",
                  }
                : {
                    color: "#2C2C2C",
                    backgroundColor: "#D8DEE9",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "12px",
                  }
            }
            onClick={() => {
              toggle("home");
            }}
          >
            HOME
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={
              activeTab === "introduction"
                ? {
                    color: "#F5F7FA",
                    backgroundColor: "#003366",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "15px",
                  }
                : {
                    color: "#2C2C2C",
                    backgroundColor: "#D8DEE9",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "12px",
                  }
            }
            onClick={() => {
              toggle("introduction");
            }}
          >
            INTRODUZIONE
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={
              activeTab === "professors"
                ? {
                    color: "#F5F7FA",
                    backgroundColor: "#003366",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "15px",
                  }
                : {
                    color: "#2C2C2C",
                    backgroundColor: "#D8DEE9",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "12px",
                  }
            }
            onClick={() => {
              toggle("professors");
            }}
          >
            DOCENTI
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={
              activeTab === "program"
                ? {
                    color: "#F5F7FA",
                    backgroundColor: "#003366",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "15px",
                  }
                : {
                    color: "#2C2C2C",
                    backgroundColor: "#D8DEE9",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "12px",
                  }
            }
            onClick={() => {
              toggle("program");
            }}
          >
            PROGRAMMA
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={
              activeTab === "participation"
                ? {
                    color: "#F5F7FA",
                    backgroundColor: "#003366",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "15px",
                  }
                : {
                    color: "#2C2C2C",
                    backgroundColor: "#D8DEE9",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "12px",
                  }
            }
            onClick={() => {
              toggle("participation");
            }}
          >
            PARTECIPAZIONE
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={
              activeTab === "information"
                ? {
                    color: "#F5F7FA",
                    backgroundColor: "#003366",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "15px",
                  }
                : {
                    color: "#2C2C2C",
                    backgroundColor: "#D8DEE9",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "12px",
                  }
            }
            onClick={() => {
              toggle("information");
            }}
          >
            INFORMAZIONI
          </NavLink>
        </NavItem>
      </Nav>
    </>
  );

  const tableProfessors = (professors) => (
    <div>
      {/*
      {Object.entries(professors)
        .sort((a, b) => a - b)
        .map(([committeeName, committeeMembers]) => (
          <div key={committeeName}>
            <h2
              style={{
                textAlign: "center",
                backgroundColor: "#003366",
                color: "white",
                borderRadius: "10px",
              }}
            >
              {committeeName.toUpperCase()}
            </h2>
            <div
              className="row"
              style={{ marginBottom: "30px", paddingLeft: "20px" }}
            >
              {committeeMembers &&
                committeeMembers.map((member, index) => (
                  <div
                    className="row"
                    style={{
                      borderBottom: "1px dashed gray",
                      color: "#2C2C2C",
                    }}
                  >
                    <div
                      className="col-4"
                      style={{ borderRight: "1px dashed gray" }}
                    >
                      {member.person}
                    </div>
                    <div
                      className="col-8"
                      dangerouslySetInnerHTML={{
                        __html: member.who,
                      }}
                    />
                  </div>
                ))}
            </div>
          </div>
        ))}
        */}

      {Object.entries(professors)
        .sort((a, b) => a[0] - b[0]) // Ordina per il campo 'order'
        .map(([order, { what, members }]) => (
          <div key={order} style={{ marginBottom: "40px" }}>
            <h2
              style={{
                textAlign: "center",
                backgroundColor: "#003366",
                color: "white",
                borderRadius: "10px",
                padding: "5px",
              }}
            >
              {what.toUpperCase()}
            </h2>
            <div
              className="row"
              style={{ marginBottom: "30px", paddingLeft: "20px" }}
            >
              {members &&
                members.map((member, index) => (
                  <div
                    key={index}
                    className="row"
                    style={{
                      borderBottom: "1px dashed gray",
                      color: "#2C2C2C",
                      padding: "10px 0",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="col-6"
                      style={{
                        padding: "0 10px",
                        fontWeight: "bold",
                      }}
                    >
                      {member.person}
                    </div>
                    <div
                      className="col-6"
                      style={{
                        padding: "0 10px",
                        borderLeft: "1px dashed gray",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: member.who,
                      }}
                    />
                  </div>
                ))}
            </div>
          </div>
        ))}
    </div>
  );

  const tableProgram = (programs) => (
    <div>
      {Object.entries(programs).map(([programDay, programEvent]) => (
        <div key={programDay}>
          <h2
            style={{
              textAlign: "center",
              backgroundColor: "#003366",
              color: "white",
              borderRadius: "10px",
            }}
          >
            {programDay.toUpperCase()}
          </h2>
          <div
            className="row"
            style={{ marginBottom: "30px", paddingLeft: "20px" }}
          >
            {programEvent &&
              programEvent.map((member, index) => (
                <div
                  className="row"
                  style={{ borderBottom: "1px dashed gray", color: "#2C2C2C" }}
                >
                  <div
                    className="col-3"
                    style={{
                      borderRight: "1px dashed gray",
                      textAlign: "center",
                    }}
                  >
                    {member.time &&
                      (member.time.endsWith("a.m.") ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-brightness-high-fill"
                          viewBox="0 0 16 16"
                          style={{ marginRight: "10px" }}
                        >
                          <path d="M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708" />
                        </svg>
                      ) : member.time.endsWith("p.m.") ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-moon-stars"
                          viewBox="0 0 16 16"
                          style={{ marginRight: "10px" }}
                        >
                          <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278M4.858 1.311A7.27 7.27 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.32 7.32 0 0 0 5.205-2.162q-.506.063-1.029.063c-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286" />
                          <path d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.73 1.73 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.73 1.73 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.73 1.73 0 0 0 1.097-1.097zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z" />
                        </svg>
                      ) : null)}
                    {member.time}
                  </div>
                  <div
                    className="col-6"
                    style={{
                      borderRight: "1px dashed gray",
                      textAlign: "center",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: member.what,
                    }}
                  ></div>
                  <div className="col-3">{member.who}</div>
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  );

  const visualizationMode = (content) => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: "70%" }}>
        <div
          style={{
            boxShadow: "0 0 10px 2px #003366",
            margin: "20px",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          {content}
        </div>
      </div>
    </div>
  );

  const totalContent = (
    <div style={{ backgroundColor: "#FAFAFA" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        {navContents}
      </div>
      <div className="row">
        <TabContent activeTab={activeTab}>
          <TabPane tabId="home">
            <div style={{ textAlign: "center" }}>
              {/*
              {contentSchoolHome && (
                <div
                  style={{
                    boxShadow: "0 0 10px 10px white",
                    margin: "20px",
                    padding: "10px",
                    borderRadius: "10px",
                  }}
                  dangerouslySetInnerHTML={{ __html: contentSchoolHome }}
                />
              )}
              */}
              {contentSchoolHome &&
                visualizationMode(
                  <div
                    style={{
                      padding: "10px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: contentSchoolHome,
                    }}
                  />
                )}
            </div>
          </TabPane>
          <TabPane tabId="introduction">
            <div style={{ textAlign: "center" }}>
              {/*
              {contentSchool && (
                <div
                  style={{
                    boxShadow: "0 0 10px 10px white",
                    margin: "20px",
                    padding: "10px",
                    borderRadius: "10px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: contentSchoolIntroduction,
                  }}
                />
              )}
              */}
              {contentSchoolIntroduction &&
                visualizationMode(
                  <div
                    style={{
                      padding: "10px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: contentSchoolIntroduction,
                    }}
                  />
                )}
            </div>
          </TabPane>
          <TabPane tabId="professors">
            <div style={{ textAlign: "center" }}>
              {/*}
              {contentSchool && (
                <div
                  style={{
                    boxShadow: "0 0 10px 10px white",
                    margin: "20px",
                    padding: "10px",
                    borderRadius: "10px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: contentSchoolProfessorsTxt,
                  }}
                />
              )}
              {contentSchoolProfessors &&
                tableProfessors(contentSchoolProfessors)}
              */}

              {/*
              {contentSchoolProfessors ? (
                tableProfessors(contentSchoolProfessors)
              ) : contentSchoolProfessorsTxt ? (
                <div
                  style={{
                    boxShadow: "0 0 10px 10px white",
                    margin: "20px",
                    padding: "10px",
                    borderRadius: "10px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: contentSchoolProfessorsTxt,
                  }}
                />
              ) : null}
               */}

              {contentSchoolProfessors
                ? visualizationMode(tableProfessors(contentSchoolProfessors))
                : contentSchoolProfessorsTxt
                ? visualizationMode(
                    <div
                      style={{
                        padding: "10px",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: contentSchoolProfessorsTxt,
                      }}
                    />
                  )
                : null}
            </div>
          </TabPane>
          <TabPane tabId="program">
            <div style={{ textAlign: "center" }}>
              {/*
              {contentSchool && (
                <div
                  style={{
                    boxShadow: "0 0 10px 10px white",
                    margin: "20px",
                    padding: "10px",
                    borderRadius: "10px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: contentSchoolProgramTxt,
                  }}
                />
              )}
              {contentSchoolProgram && (
                <>{tableProgram(contentSchoolProgram)}</>
              )}
              */}
              {/*
              {contentSchoolProgram ? (
                tableProgram(contentSchoolProgram)
              ) : contentSchoolProgramTxt ? (
                <div
                  style={{
                    boxShadow: "0 0 10px 10px white",
                    margin: "20px",
                    padding: "10px",
                    borderRadius: "10px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: contentSchoolProgramTxt,
                  }}
                />
              ) : null}
              */}

              {contentSchoolProgram
                ? visualizationMode(tableProgram(contentSchoolProgram))
                : contentSchoolProgramTxt
                ? visualizationMode(
                    <div
                      style={{
                        padding: "10px",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: contentSchoolProgramTxt,
                      }}
                    />
                  )
                : null}
            </div>
          </TabPane>
          <TabPane tabId="participation">
            <div style={{ textAlign: "center" }}>
              {/*
              {contentSchool && (
                <div
                  style={{
                    boxShadow: "0 0 10px 10px white",
                    margin: "20px",
                    padding: "10px",
                    borderRadius: "10px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: contentSchoolParticipation,
                  }}
                />
              )}
              */}

              {contentSchoolParticipation &&
                visualizationMode(
                  <div
                    style={{
                      padding: "10px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: contentSchoolParticipation,
                    }}
                  />
                )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "70%" }}>
                  {formattedToday <= dateRegistration ? (
                    <div
                      style={{
                        boxShadow: "0 0 10px 2px #003366",
                        margin: "20px",
                        padding: "10px",
                        borderRadius: "10px",
                        color: "#2C2C2C",
                      }}
                    >
                      <SchoolRegistration
                        name_school={name_school}
                        year_school={year_school}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        boxShadow: "0 0 5px 2px red",
                        margin: "20px",
                        padding: "10px",
                        borderRadius: "10px",
                        color: "white",
                        backgroundColor: "red",
                      }}
                    >
                      <h2>Il termine per l'iscrizione è scaduto.</h2>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </TabPane>
          <TabPane tabId="information">
            <div style={{ textAlign: "center" }}>
              {/*
              {contentSchool && (
                <div
                  style={{
                    boxShadow: "0 0 10px 10px white",
                    margin: "20px",
                    padding: "10px",
                    borderRadius: "10px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: contentSchoolInformation,
                  }}
                />
              )}
              */}
              {contentSchoolInformation &&
                visualizationMode(
                  <div
                    style={{
                      padding: "10px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: contentSchoolInformation,
                    }}
                  />
                )}
            </div>
          </TabPane>
        </TabContent>
      </div>
    </div>
  );

  return (
    <div>
      <Toaster />
      <div className="row">
        <div>{totalContent}</div>
      </div>
    </div>
  );
};

export default School;
